export const fetchGroups = () => ({
  method: 'GET',
  url: '/collaboration/contract/5eeeab487ab2da14e9f6d790/members'
});

export const fetchMembersOnly = () => ({
  method: 'GET',
  url: '/collaboration/membersOnly'
});

export const fetchGroupsOnly = () => ({
  method: 'GET',
  url: '/collaboration/groupsOnly'
});

export const fetchMembers = ({ contractId, documentType = 'contract' }) => ({
  method: 'GET',
  url: `/collaboration/${documentType}/${contractId}/members`
})

export const fetchContractCollaborators = ({ contractId, type = 'watchers' }) => ({
  method: 'GET',
  url: `/collaboration/contracts/${contractId}/collaborators?type=${type}`
})

export const sendMessage = ({ contractId, ...data }) => ({
  method: 'POST',
  url: `/ncontracts/${contractId}/sendmessage`,
  data
})

export const sendSpecialApproval = ({ contractId, ...data }) => ({
  method: 'POST',
  url: `/collaboration/approval/special/${contractId}`,
  data
})

export const delegateGroup = ({ contractId, ...data }) => ({
  method: 'POST',
  url: `/collaboration/delegate/${contractId}/5b45a2c99d772c8a834e3149/group`,
  data
})

export const createReviewComment = ({ documentType, contractId, elementId,  ...data }) => ({
  method: 'POST',
  url: `/collaboration/comments/${documentType}/${contractId}/${elementId}`,
  data
})

export const respondReviewComment = ({ documentType, contractId, elementId,commentId,  ...data }) => ({
  method: 'PATCH',
  url: `/collaboration/comments/${documentType}/${contractId}/${elementId}/${commentId}`,
  data
})

export const respondParticipantComment = ({ contractId,  ...data }) => ({
  method: 'POST',
  url: `/client/contracts/${contractId}/answercommentelement`,
  data
})

export const deleteReviewComment = ({ documentType, contractId, elementId, commentId,  ...data }) => ({
  method: 'DELETE',
  url: `/collaboration/comments/${documentType}/${contractId}/${elementId}/${commentId}`,
  data
})

export const createConversationComment = ({ documentType, contractId,  ...data }) => ({
  method: 'POST',
  url: `/collaboration/conversation/${documentType}/${contractId}`,
  data
})

export const respondConversationComment = ({ documentType, contractId, commentId,  ...data }) => ({
  method: 'PATCH',
  url: `/collaboration/conversation/${documentType}/${contractId}/${commentId}`,
  data
})

export const respondSignComment = ({ documentType, contractId,  ...data }) => ({
  method: 'POST',
  url: `/client/contracts/${contractId}/answercomment`,
  data
})

